import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDropDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M480-360 280-560h400L480-360Z" })
});
export default SvgArrowDropDown;
